<template>
  <div class="gnb-search-box">
    <MailSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'mail'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BoardSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'bbs'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <ScheduleSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'schedule'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <InsaSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'insa'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <ApprovalSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'approval'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BillDocModifyList
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'bill-doc-modify-list'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BillSummaryOut
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'bill-summary-out'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BillPartnerList
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'bill-partner-list'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BillPersonalPartnerList
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'bill-personal-partner-list'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <AddressSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'address'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <TeamMailSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'team-mail'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <BookingSearchBox v-if="searchType === 'booking'" :domain="domain" />

    <GroupSearchBox
      v-click-outside="hideSearchDropDown"
      v-if="searchType === 'group'"
      :is-search-drop-down-visible="isSearchDropDownVisible"
      @set-is-search-drop-down-visible="setIsSearchDropDownVisible"
    />

    <SmsResultSearchBox v-if="searchType === 'sms-send-result'" />
    <SmsDenySearchBox v-if="searchType === 'sms-deny'" />
    <SmsUseSearchBox v-if="searchType === 'sms-use'" />
    <TalkResultSearchBox v-if="searchType === 'talk-result'" />
    <TalkUseSearchBox v-if="searchType === 'talk-use'" />
    <TalkTemplateSearchBoxCopy v-if="searchType === 'talk-template'" />

    <button class="close-button" @click="closeSearchBox">닫기</button>
  </div>
</template>

<script>
import AddressSearchBox from './AddressSearchBox';
import ApprovalSearchBox from './ApprovalSearchBox';
import BoardSearchBox from './BoardSearchBox';
import BookingSearchBox from './BookingSearchBox';
import GroupSearchBox from './GroupSearchBox';
import InsaSearchBox from './InsaSearchBox';
import MailSearchBox from './MailSearchBox';
import ScheduleSearchBox from './ScheduleSearchBox';
import TeamMailSearchBox from './TeamMailSearchBox';
import BillDocModifyList from './bill/BillDocModifyList';
import BillPartnerList from './bill/BillPartnerList';
import BillPersonalPartnerList from './bill/BillPersonalPartnerList';
import BillSummaryOut from './bill/BillSummaryOut';
import SmsDenySearchBox from './sms/SmsDenySearchBox';
import SmsResultSearchBox from './sms/SmsResultSearchBox';
import SmsUseSearchBox from './sms/SmsUseSearchBox';
import TalkResultSearchBox from './sms/TalkResultSearchBox.vue';
import TalkTemplateSearchBoxCopy from './sms/TalkTemplateSearchBox copy.vue';
import TalkUseSearchBox from './sms/TalkUseSearchBox.vue';

export default {
  name: 'SearchBox',
  props: {
    searchType: {
      required: true,
    },
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
    domain: {
      type: String,
    },
  },
  components: {
    MailSearchBox,
    BoardSearchBox,
    ScheduleSearchBox,
    InsaSearchBox,
    ApprovalSearchBox,
    BillDocModifyList,
    BillSummaryOut,
    BillPartnerList,
    BillPersonalPartnerList,
    BookingSearchBox,
    GroupSearchBox,
    SmsResultSearchBox,
    SmsDenySearchBox,
    SmsUseSearchBox,
    AddressSearchBox,
    TeamMailSearchBox,
    TalkResultSearchBox,
    TalkTemplateSearchBoxCopy,
    TalkUseSearchBox,
  },
  methods: {
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    hideSearchDropDown() {
      this.$emit('set-is-search-drop-down-visible', false);
    },
    closeSearchBox() {
      this.$emit('set-is-search-box-visible', false);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/base/variables.scss';

.gnb-search-box {
  //! 헤더 스타일 복사 .new_header
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  align-items: center;
  padding: 0 10px 0 20px;
  height: $headerHeight;
  border-bottom: 1px solid #dadce0;
  background: #fff;
  color: #676767;
  font-size: 14px;
  z-index: 2;
  box-sizing: border-box;

  .close-button {
    padding: 10px;
    white-space: nowrap;
    color: #909090;
  }

  @media only screen and (min-width: 900px) and (max-width: 1279px) {
    position: absolute;
    width: calc(100% + 10px);
    right: -10px;
    padding: 0;
  }

  @media (min-width: 1280px) {
    position: static;
    height: auto;
    padding: 0;
    border: none;

    .close-button {
      display: none;
    }
  }
}

::v-deep .classForClickOutside {
  display: none;
  @media only screen and (min-width: 900px) {
    display: block;
    flex-grow: 1;
  }
}

::v-deep .search {
  display: flex;
  flex: auto;

  &-revoke {
    margin-right: 10px;
    color: #2985db;
    white-space: nowrap;

    &__icon {
      margin-right: 6px;
      font-size: 14px;
    }
  }

  &-bar {
    box-sizing: border-box;
    width: 100%;
    height: 33px;
    padding: 7px 12px 8px;
    display: flex;
    flex-direction: row-reverse;
    gap: 12px;
    border: 1px solid #d6d6d6;
    border-radius: 16.5px;
    align-items: center;

    &:focus-within {
      border: solid 1px #909090;
    }

    & input {
      width: 100%;
      border: none;
      outline: none;

      &::placeholder {
        color: #c4c4c4;
        font-size: 14px;
      }
    }

    .search-button > .fa-search {
      color: #909090;
    }
  }

  @media (min-width: 900px) {
    position: relative;
    justify-content: flex-end;

    &-bar {
      max-width: $searchBarMaxWidth;
      flex-direction: row;
    }
  }

  &-dropdown {
    position: absolute;
    top: $headerHeight;
    left: 0;
    width: 100vw;

    &__menu {
      padding: 10px 0;
      font-size: 14px;
      background: #fff;
      border: solid 1px #909090;
      border-radius: 4px;
      box-shadow: 2px 5px 4px 0 rgba(0, 0, 0, 0.16);
      z-index: 110;

      & > li > a {
        padding: 10px 20px;
        display: block;
        color: #333333;
        &:hover {
          background-color: #eff4fc;
        }
      }

      &--row {
        cursor: pointer;
      }

      .active > a {
        background-color: #eff4fc;
      }

      .contents-search {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .divider {
        height: 1px;
        margin: 8px 10px;
        background-color: #d6d6d6;
      }
    }

    @media (min-width: 900px) {
      width: 100%;
      max-width: $searchBarMaxWidth;
      // top: calc(($headerHeight - $searchBarHeight) / 2 + $searchBarHeight);
      top: calc((60px - 33px) / 2 + 33px);
      right: 0;
      left: auto;
    }
  }

  & .bold {
    font-weight: 700;
  }

  & .blind {
    display: block;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border: 0;
    background: 0;
    font-size: 0;
    line-height: 0;
  }

  & .point-color {
    color: $primary-color;
  }
}
</style>
